/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WearDirection = {
    /**
    * Increasing
    */
    NUMBER_1: 1,
    /**
    * Decreasing
    */
    NUMBER_2: 2,
    /**
    * Unknown
    */
    NUMBER_MINUS_1: -1
} as const;
export type WearDirection = typeof WearDirection[keyof typeof WearDirection];


export function instanceOfWearDirection(value: any): boolean {
    for (const key in WearDirection) {
        if (Object.prototype.hasOwnProperty.call(WearDirection, key)) {
            if (WearDirection[key as keyof typeof WearDirection] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WearDirectionFromJSON(json: any): WearDirection {
    return WearDirectionFromJSONTyped(json, false);
}

export function WearDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): WearDirection {
    return json as WearDirection;
}

export function WearDirectionToJSON(value?: WearDirection | null): any {
    return value as any;
}

export function WearDirectionToJSONTyped(value: any, ignoreDiscriminator: boolean): WearDirection {
    return value as WearDirection;
}

